import { z } from 'zod';
import { COMMISSION_BASES, COMMISSION_TARGET_POLICIES } from './commissions.js';

const MonthString = z
  .string()
  .regex(/^\d{4}-\d{2}$/, 'الشهر بصيغة سنة-شهر، مثل 2026-08.');

/**
 * إنشاء دورة عمولات.
 *
 * القواعد اختيارية: تُترك ليأخذها النظام من إعدادات الشركة، وتُملأ حين
 * تُستثنى دورة بعينها.
 */
export const CreateCommissionRunSchema = z.object({
  period: MonthString,
  basis: z.enum(COMMISSION_BASES).optional(),
  targetPolicy: z.enum(COMMISSION_TARGET_POLICIES).optional(),
  defaultRate: z.number().min(0, 'النسبة لا تكون سالبة.').max(100, 'النسبة لا تتجاوز مئة.').optional(),
  notes: z.string().trim().max(1000).optional(),
});

export const ListCommissionRunsSchema = z.object({
  year: z.coerce.number().int().min(2000).max(2100).optional(),
});

export type CreateCommissionRunInput = z.infer<typeof CreateCommissionRunSchema>;
